import { BehaviorSubject } from 'rxjs'

class KionMainService {
  isFooterVisible = new BehaviorSubject(true)
}

export const mainService = new KionMainService()
